import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
    mt2: {
        marginTop: theme.spacing(2)
    },
    ml2: {
        marginLeft: theme.spacing(2)
    },
    dfr: {
        flexDirection: 'row'
    },
    btnDanger: {
        backgroundColor: 'red',
        color: 'white'
    }
});
